import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import HeaderNotificationModel from "../HeaderNotificationModel";
import { userLogout } from "../../actions/authActions";
import defaultImg from "../../assetsAdmin/img/avatarProfile.png";
import logonew from "../../assetsAdmin/img/footerlogoresize.png";
import logo10 from "../../assets/img/logo.png";
import logowhite from "../../assets/img/logo-white.png";
import logosmall from "../../assets/img/logo-small.png";
import { useIdleTimer } from "react-idle-timer";
import { BUCKET_BASE_URL } from "../../constants";
// import { useEffect } from 'react'

const AdminHeader = ({ title }) => {
  // const onPrompt = () => {
  //     window.alert("onPrompt")
  //   // Fire a Modal Prompt
  // }

  const onIdle = () => {
    logout();
    setTimeout(() => window.alert("session timeout"), 5000);
    // window.alert("session timeout")
    // Close Modal Prompt
    // Do some idle action like log out your user
  };

  const onActive = (event) => {
    // window.alert("onActive")
    // Close Modal Prompt
    // Do some active action
  };

  // const onAction = (event) => {
  //     window.alert("onAction")
  //   // Do something when a user triggers a watched event
  // }

  const {
    start,
    reset,
    activate,
    pause,
    resume,
    isIdle,
    isPrompted,
    isLeader,
    getTabId,
    getRemainingTime,
    getElapsedTime,
    getLastIdleTime,
    getLastActiveTime,
    getTotalIdleTime,
    getTotalActiveTime,
  } = useIdleTimer({
    //   onPrompt,
    onIdle,
    onActive,
    //   onAction,
    timeout: 1000 * 60 * 10,
    //   timeout: 1000 * 10,
    promptTimeout: 0,
    events: [
      "mousemove",
      "keydown",
      "wheel",
      "DOMMouseScroll",
      "mousewheel",
      "mousedown",
      "touchstart",
      "touchmove",
      "MSPointerDown",
      "MSPointerMove",
      "visibilitychange",
      // 'blur'
    ],
    immediateEvents: [],
    debounce: 0,
    throttle: 0,
    eventsThrottle: 200,
    element: document,
    startOnMount: true,
    startManually: false,
    stopOnIdle: false,
    //   crossTab: false,
    crossTab: true,
    name: "idle-timer",
    syncTimers: 0,
    leaderElection: false,
  });
  const dispatch = useDispatch();
  const [showDropDownMessage, setshowDropDownMessage] = useState(false);
  const [opensidedrawer, setopensidedrawer] = useState(false);
  const [openDrop, setopenDrop] = useState(false);
  // const [showDropDown, setshowDropDown] = useState(false)
  // const [showDropDownFlag, setshowDropDownFlag] = useState(false)
  const auth = useSelector((state) => state.auth);
  const mail = useSelector((state) => state.mail);
  const notifications = useSelector((state) => state.notifications);

  // const openDropDown = () => {
  // setshowDropDown((state) => !state)
  // setshowDropDownMessage(false)
  // setshowDropDownFlag(false)
  // setopenDrop(false)
  // }
  // const openDropDownFlag = () => {
  // setshowDropDownFlag((state) => !state)
  // setshowDropDown(false)
  // setshowDropDownMessage(false)
  // setopenDrop(false)
  // }
  const openDropDownMessage = () => {
    setshowDropDownMessage((state) => !state);
    setopenDrop(false);
    // setshowDropDown(false)
    // setshowDropDownFlag(false)
  };
  const toggleDriver = () => {
    setopensidedrawer((state) => !state);
  };
  const openDropDownMenu = () => {
    setopenDrop((state) => !state);
    setshowDropDownMessage(false);
    // setshowDropDown(false)
    // setshowDropDownFlag(false)
  };
  // const [ timeOut, setTimeOut ] = useState(0)
  // useEffect(()=>{
  //     setInterval(() =>
  //         setTimeOut((timeOut) => timeOut+1)
  //     , 10000);
  // },[])
  // console.log(timeOut, "timeOut")
  // useEffect(()=>{
  //     if (timeOut >= 10){
  //         window.alert("session timeout")
  //         logout()
  //     }
  // },[timeOut])

  let navigate = useNavigate();
  const navigateUser = () => {
    // dispatch(updateUserLoginInfo({
    //     _id: auth.activeUserCountry.id,
    //     loginStatus:false
    // }))
    navigate("/login");
  };
  const logout = async (e) => {
    // console.log("ghkhkhkjhkjhkhk,,hkjhkjh,,jgjh")
    auth && auth.activeUserCountry
      ? await dispatch(
          userLogout(
            { refreshToken: auth.tokens.refresh.token },
            navigateUser,
            auth.activeUserCountry.id
          )
        )
      : await dispatch(
          userLogout({ refreshToken: auth.tokens.refresh.token }, navigateUser)
        );
  };
  const [showAdministratorDropDown, setshowAdministratorDropDown] =
    useState(false);
  const [showReportDropDown, setshowReportDropDown] = useState(false);
  const openAdministratorDropDown = () => {
    setshowAdministratorDropDown(
      (showAdministratorDropDown) => !showAdministratorDropDown
    );
    setshowReportDropDown(false);
  };
  const openReportDropDown = () => {
    setshowReportDropDown((showReportDropDown) => !showReportDropDown);
    setshowAdministratorDropDown(false);
  };
  //   window.onclick = setshowDropDownMessage()
  // document.
  let j = 0;
  let jj = 0;

  // // Function to call when the user logs in
  const [showWelcomeMessage, setShowWelcomeMessage] = useState(false);
  const location = useLocation();

  const handleLogin = () => {
    setShowWelcomeMessage(true);
    // Automatically hide the welcome message after 5 seconds
    setTimeout(() => {
      setShowWelcomeMessage(false);
    }, 10000);
  };

  useEffect(() => {
    // Check if the current path is "/dashboard"
    if (location.pathname === "/dashboard") {
      // Simulating user login. Replace with actual login logic.
      handleLogin();
    }
  }, [location.pathname]);
  return (
    <>
      <div className="header header-one">
        <div className="header-left header-left-one  d-flex justify-content-between">
          <div>
            <NavLink to="/dashboard" className="logo">
              <img src={logo10} alt="Logo" />
            </NavLink>
            <NavLink to="/dashboard" className="white-logo">
              <img src={logowhite} alt="Logo" />
            </NavLink>
            <NavLink to="/dashboard" className="logo logo-small d-lg-none">
              <img src={logosmall} alt="Logo" width="30" height="30" />
            </NavLink>
          </div>

          <div>
            <a id="toggle_btn">
              <i class="fas fa-bars"></i>
            </a>
            <a class="mobile_btn" id="mobile_btn">
              <i class="fas fa-bars"></i>
            </a>
          </div>
        </div>

        <div class=" header-right header-right-one  ">
          <div class="top-nav-search">
            <div className="header-title">
              {showWelcomeMessage && (
                <h4>
                  Welcome {auth.user.firstName} {auth.user.lastName}!
                </h4>
              )}
              <span className="fs-6">{title ? title : "Dashboard"}</span>
            </div>
          </div>
          <ul class="nav nav-tabs user-menu">
            <li key={jj++} class="nav-item dropdown">
              <a
                href="#"
                class="dropdown-toggle nav-link"
                data-bs-toggle="dropdown"
                onClick={openDropDownMessage}
              >
                <i class="fa fa-comment"></i>
                {notifications.list.length > 0 && (
                  <span className="badge badge-pill">
                    {notifications.list.length -
                      notifications.list.filter((x) =>
                        x.readBy.find((y) => y.readerId == auth.user.id)
                      ).length}
                  </span>
                )}
              </a>
              <HeaderNotificationModel
                showDropDownMessage={showDropDownMessage}
                openDropDownMessage={openDropDownMessage}
              />
            </li>
            <div class="topbar-divider "></div>
            <li
              key={jj++}
              class="nav-item dropdown has-arrow main-drop"
              onClick={openDropDownMenu}
            >
              <a
                href="#"
                class="dropdown-toggle nav-link"
                data-bs-toggle="dropdown"
              >
                <span class="user-img">
                  {auth.user && auth.user.profilePic ? (
                    auth.user.profilePic.fileUrl && (
                      <>
                        <img
                          src={BUCKET_BASE_URL + auth.user.profilePic.fileUrl}
                          alt=""
                        />
                      </>
                    )
                  ) : (
                    <img alt="" src={defaultImg} />
                  )}
                  <span class="status online"></span>
                </span>
                <span>
                  {auth.user.firstName} {auth.user.lastName}
                </span>
              </a>
              <div
                class={`dropdown-menu ${openDrop ? "show" : "hide"}`}
                style={{ borderRadius: "0px 0px 15px 15px" }}
              >
                <Link class="dropdown-item" to="/admin-profile">
                  {/* <i data-feather="user" class="me-1"></i> */}
                  <i className="la la-user" style={{ fontSize: "20px" }}></i>
                  My Profile
                </Link>
                <Link class="dropdown-item" to="/settings">
                  {/* <i data-feather="settings" class="me-1"></i> */}
                  <i className="la la-cog" style={{ fontSize: "20px" }}></i>
                  Settings
                </Link>
                <a
                  className="dropdown-item"
                  style={{ cursor: "pointer" }}
                  onClick={logout}
                >
                  <i
                    className="la la-sign-out"
                    style={{ fontSize: "20px" }}
                  ></i>
                  Logout
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};
export default AdminHeader;

{
  /* <div className="main-wrapper">
        <div className="header">
          <div className="header-left">
            <NavLink to="/dashboard" className="logo">
              <img src={logonew} height="33" alt="" />
            </NavLink>
          </div>
          <div className="page-title-box">
            <h3>Riyo Work</h3>
          </div>
          <NavLink
            id="mobile_btn"
            className="mobile_btn"
            to="#"
            onClick={toggleDriver}
          >
            <i className="fa fa-bars"></i>
          </NavLink>
          <ul className="nav user-menu">
            <li key={jj++} className="nav-item dropdown">
              <NavLink
                to="#"
                className="dropdown-toggle nav-link"
                data-toggle="dropdown"
                onClick={openDropDownMessage}
              >
                <i className="fa fa-comment-o"></i>
                {notifications.list.length > 0 && (
                  <span className="badge badge-pill">
                    {notifications.list.length -
                      notifications.list.filter((x) =>
                        x.readBy.find((y) => y.readerId == auth.user.id)
                      ).length}
                  </span>
                )}
              </NavLink>
              <HeaderNotificationModel
                showDropDownMessage={showDropDownMessage}
                openDropDownMessage={openDropDownMessage}
              />
            </li>
            <li
              key={jj++}
              className="nav-item dropdown has-arrow main-drop"
              onClick={openDropDownMenu}
            >
              <NavLink
                to="#"
                className="dropdown-toggle nav-link"
                data-toggle="dropdown"
              >
                <span className="avatar">
                  {auth.user && auth.user.profilePic ? (
                    auth.user.profilePic.fileUrl && (
                      <>
                        <img
                          alt="Profile Pic"
                          src={BUCKET_BASE_URL + auth.user.profilePic.fileUrl}
                          style={{ objectFit: "fill", height: "100%" }}
                        />
                      </>
                    )
                  ) : (
                    <img alt="" src={defaultImg} />
                  )}
                  <span
                    className="status online"
                    style={{
                      float: "right",
                      marginTop: "-0.6rem",
                      position: "relative",
                      border: "2px solid #fff",
                    }}
                  ></span>
                </span>
                <span>Admin</span>
              </NavLink>
              <div
                className={`dropdown-menu dropdown-profile ${
                  openDrop ? "show" : "hide"
                }`}
              >
                <NavLink className="dropdown-item" to="/admin-profile">
                  My Profile
                </NavLink>
                <NavLink className="dropdown-item" to="/settings">
                  Settings
                </NavLink>
                <a
                  className="dropdown-item"
                  style={{ cursor: "pointer" }}
                  onClick={logout}
                >
                  Logout
                </a>
              </div>
            </li>
          </ul>
          <div className="dropdown mobile-user-menu" onClick={openDropDownMenu}>
            <NavLink
              to="#"
              className="nav-link dropdown-toggle"
              data-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fa fa-ellipsis-v"></i>
            </NavLink>
            <div
              className={`dropdown-menu dropdown-menu-right ${
                openDrop ? "show" : "hide"
              }`}
            >
              <NavLink className="dropdown-item" to="/admin-profile">
                My Profile
              </NavLink>
              <NavLink className="dropdown-item" to="/settings">
                Settings
              </NavLink>
              <a
                className="dropdown-item"
                style={{ cursor: "pointer" }}
                onClick={logout}
              >
                Logout
              </a>
            </div>
          </div>

          yeh side drawer ka code hai jab window minimize ya choti choti ha toh nazar ata hai
          <div
            className={`sidebar ${
              opensidedrawer ? "showsidebar" : "hidesidebar"
            }`}
            id="sidebar"
          >
            <div className="scrollbar scrollbar-primary">
              <div id="sidebar-menu" className="sidebar-menu">
                <ul>
                  <li key={jj++}>
                    <NavLink to="/dashboard">
                      <i className="la la-dashboard"></i>
                      <span> Dashboard</span>
                    </NavLink>
                  </li>
                  <li key={jj++}>
                    <NavLink to="/employees">
                      <i className="la la-user"></i> <span>All Employees</span>
                    </NavLink>
                  </li>
                  <li key={jj++}>
                    <NavLink to="/time-clock">
                      <i className="la la-user-clock"></i>
                      <span>Time Clock</span>
                    </NavLink>
                  </li>
                  <li key={jj++}>
                    <NavLink to="/shift-scheduling">
                      <i className="la la-users"></i>
                      <span>Shift &amp; Schedule</span>
                    </NavLink>
                  </li>
                  <li key={jj++}>
                    <NavLink to="/tracking">
                      <i className="la la-location-arrow"></i>
                      <span>Tracking</span>
                    </NavLink>
                  </li>
                  <li key={jj++}>
                    <NavLink to="/leaves">
                      <i className="la la-external-link-square"></i>
                      <span>Leaves </span>
                    </NavLink>
                  </li>
                  <li key={jj++}>
                    <NavLink to="/training">
                      <i className="la la-graduation-cap"></i>{" "}
                      <span> Training </span>
                    </NavLink>
                  </li>
                  <li key={jj++}>
                    <NavLink to="/payroll-items">
                      <i className="la la-money"></i> <span> Payroll </span>
                    </NavLink>
                  </li>
                  <li key={jj++} className="submenu">
                    <NavLink to="#" onClick={openReportDropDown}>
                      <i className="la la-th-list"></i>
                      <span>Reports</span> <span className="menu-arrow"></span>
                    </NavLink>
                    <ul className={`${showReportDropDown ? "show" : "hide"}`}>
                      <li key={jj++}>
                        <NavLink to="/shift-report">
                          <i className="la la-file-invoice"></i>{" "}
                          <span>Shift Reports</span>
                        </NavLink>
                      </li>
                      <li key={jj++}>
                        <NavLink to="/timeclk-report">
                          <i className="la la-file-invoice"></i>{" "}
                          <span>Time Clock Reports</span>
                        </NavLink>
                      </li>
                      <li key={jj++}>
                        <NavLink to="/attend-report">
                          <i className="la la-file-invoice"></i>{" "}
                          <span>Attendance Reports</span>
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                  <li key={jj++} className="submenu">
                    <NavLink to="#" onClick={openAdministratorDropDown}>
                      <i className="las la-toolbox"></i>
                      <span>Administration</span>{" "}
                      <span className="menu-arrow"></span>
                    </NavLink>
                    <ul
                      className={`${
                        showAdministratorDropDown ? "show" : "hide"
                      }`}
                    >
                      <li key={jj++}>
                        <NavLink to="/locations">
                          <i className="la la-map-marker"></i>{" "}
                          <span>Locations</span>
                        </NavLink>
                      </li>
                      <li key={jj++}>
                        <NavLink to="/policies">
                          <i className="la la-file-pdf-o"></i>{" "}
                          <span>Policies</span>
                        </NavLink>
                      </li>
                      <li key={jj++}>
                        <NavLink to="/users">
                          <i className="la la-user-plus"></i> <span>Users</span>
                        </NavLink>
                      </li>
                      <li key={jj++}>
                        <NavLink to="/subscriptions-company">
                          <i className="la la-hand-o-up"></i>{" "}
                          <span> Subscriptions </span>
                        </NavLink>
                      </li>
                      <li key={jj++}>
                        <NavLink to="/settings">
                          <i className="la la-cog"></i> <span> Settings </span>
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                  <li key={jj++}>
                    <a style={{ cursor: "pointer" }} onClick={logout}>
                      <i className="la la-power-off"></i> <span>Logout</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`sidebar-overlay ${opensidedrawer ? "opened" : ""}`}
      ></div> */
}
